import { Badge } from '@/components/ui/badge';

const CHANNEL_CONFIG: Record<
  string,
  { label: string; variant: 'default' | 'secondary' | 'outline' }
> = {
  WHATSAPP: { label: 'WhatsApp', variant: 'default' },
  SMS: { label: 'SMS', variant: 'secondary' },
  EMAIL: { label: 'Email', variant: 'secondary' },
  WEB_WIDGET: { label: 'Web', variant: 'outline' },
};

export const ChannelBadge = ({ channel }: { channel: string }) => {
  const config = CHANNEL_CONFIG[channel] ?? { label: channel, variant: 'outline' as const };
  return <Badge variant={config.variant}>{config.label}</Badge>;
};
